import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'quotes-history',
  templateUrl: './quotes-history.component.html',
  styleUrl: './quotes-history.component.scss',
  standalone: false,
})
export class QuotesHistoryComponent implements OnInit {
  quoteId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.getParams();
  }

  getParams() {
    this.route.queryParamMap.subscribe(params => {
      this.quoteId = params.get('id');
      this.cd.detectChanges();
    });
  }
}
